import React, { useEffect } from 'react';
import insightLeft from '../img/png/insights_background_left.png';
import insightRight from '../img/png/insights_background_right.png';
import coreImg from '../img/png/tech_insight.png';
import coreStem from '../img/png/insight_stem.png';
import InsightIcons from './subcomponents/InsightIcons';
import { AiOutlineMessage } from 'react-icons/ai';
import { FiTarget, FiUsers, FiShoppingCart } from 'react-icons/fi';
import { RiHealthBookLine } from 'react-icons/ri';
import { BsImages, BsClipboardData } from 'react-icons/bs';
import InsightsMobile from './subcomponents/InsightsMobile';
//gsap happens
import { gsap, Power3 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function Insights() {
  useEffect(() => {
    gsap.from('.icons_item', {
      duration: 1,
      x: '5',
      scale: 0.8,
      ease: Power3.easeInOut,
      scrollTrigger: {
        trigger: '.insight_container',
        start: 'top 90%',
        end: 'bottom 30%',
        // markers: true,
        toggleActions: 'restart complete',
        // delay: 0.5,
      },
      stagger: 0.3,
    });
  }, []);
  return (
    <>
      <section className='insight d-flex-col justify-content-center align-items-center'>
        <div className='insight_title text-center'>
          <h2 className='text-title'>Insights</h2>
          <h3 className=''>Measuring your audience behavioural profile</h3>
          <div className='line'></div>
        </div>
        <div className='insight_container d-flex-row justify-content-between gap-1'>
          <div className='insight_container_left d-flex-col justify-content-center'>
            <p className='text-left'>Insights-driven step by step execution</p>
            <p className='text-left text-gray'>
              Through highly powerful data collection, engineering
              infrastructure and signal detection techniques, we provide
              enterprises with high precision Digital Insights to measure HCP
              (Healthcare Professionals), patient or consumer behaviours and
              deconstruct their entire online journey.
            </p>
          </div>
          <div className='insight_container_center d-flex-col align-items-center justify-content-center gap-1'>
            <div className='core_container'>
              <img src={coreImg} alt='background' />
              {/* <ParticlesCore /> */}
            </div>
            <h3 className='text-center text-contenttitle'>Core AI Insights</h3>
          </div>
          <div className='insight_container_right d-flex-row align-items-center justify-content-between gap-3'>
            <img src={coreStem} alt='background' />
            <div className='icons d-flex-col'>
              <InsightIcons icon={<AiOutlineMessage />} text='Messaging' />
              <InsightIcons icon={<FiTarget />} text='Targeting' />
              <InsightIcons
                icon={<FiUsers />}
                text='Consumer'
                text2='Activation & Supply'
              />
              <InsightIcons
                icon={<RiHealthBookLine />}
                text='HCP'
                text2='Activation & Specialist Supply'
              />
              <InsightIcons
                icon={<FiShoppingCart />}
                text='E-Commerce'
                text2='Activation & Custom Supply'
              />
              <InsightIcons icon={<BsImages />} text='Dynamic Media Format' />
              <InsightIcons
                icon={<BsClipboardData />}
                text='CRM Data Enrichment'
              />
            </div>
          </div>
        </div>
        {/* <ParticlesComponent /> */}
        <div className='insight_background d-flex justify-content-between'>
          <div className='insight_background_left'>
            <img src={insightLeft} alt='background' />
          </div>
          <div className='insight_background_right d-flex-col justify-content-end'>
            <img src={insightRight} alt='background' />
          </div>
        </div>
      </section>
      {/* mobile */}
      <InsightsMobile />
    </>
  );
}

export default Insights;
